<template>
    <v-container fluid pa-0 ma-0>
        <v-row>
            <v-col v-if="!$route.meta.isDetail" cols="12">
                <v-row align="start">
                    <v-col>
                        <router-view name="header"></router-view>
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col>
                        <router-view></router-view>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="$route.meta.isDetail">
                <v-row align="start" no-gutters>
                    <v-col>
                        <router-view name="header"></router-view>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-scroll-x-transition>
                        <v-col
                            v-if="$route.meta.isDetail && !hide"
                            :cols="$vuetify.breakpoint.mdAndUp?3:12">
                            <router-view name="verticalHeader"></router-view>
                        </v-col>
                    </v-scroll-x-transition>

                    <v-col>
                        <v-row no-gutters>
                            <v-col
                                style="padding-top: 300px;"
                                cols="auto"
                                v-if="$vuetify.breakpoint.mdAndUp"
                            >
                                <v-btn
                                    style="margin-left: -70%"
                                    elevation="-2"
                                    dark
                                    large
                                    icon
                                    color="grey"
                                    @click="hide = !hide"
                                >
                                   <!-- <v-icon left v-if="hide">chevron_left</v-icon>
                                    <v-icon right v-if="!hide">chevron_right</v-icon>-->
                                    <v-icon left v-if="!hide">mdi-account-arrow-left-outline</v-icon>
                                    <v-icon right v-if="hide">mdi-account-arrow-right-outline</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col >
                                <router-view></router-view>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "DashView",
        data() {
            return {
                hide:false
            }
        }
    }
</script>

<style scoped>

</style>